export enum ActionTypes {
  SAVE_CURRENCIES = 'SAVE_CURRENCIES'
}
